import React, { PropsWithChildren } from "react";
import { Router as ReactRouter } from "react-router-dom";

import useHistory from "../lib/history";

export default function Router({ children }: PropsWithChildren<{}>): JSX.Element {
  const history = useHistory();
  return <ReactRouter history={history}>{children}</ReactRouter>;
}
